<template>
    <div v-if="medico_obs && medico_obs.length" class="mb-3">
        <div v-for="(obs, iox) in medico_obs" :key="iox" class="mt-1 alert alert-warning py-1 mb-0">
            <div class="d-flex justify-content-between small text-muted">
                <div>
                    <span v-if="obs.medico">{{ obs.medico.search }} | </span>
                    <span v-if="obs.dt_data">{{ $util.getFormatDate(obs.dt_data) }}</span>
                    <span> | {{ obs.st_texto }}</span>
                </div>
                <div>
                    <span v-if="obs.usuario">{{ obs.usuario.st_login }}</span>
                    <a href="#" class="text-danger ml-3" @click.prevent="remover_obs(obs)">
                        <i class="fa fa-times" aria-hidden="true"></i>
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['medico_obs'], 

    methods: { 
        remover_obs(obs) { 
            if ( !confirm("Confirma a exclusão da observação?") )
                return;

            this.$util.atualizar(this, { 
                service: 'medico_obss', 
                func: 'toggle', 
                dados: { 
                    id_medico_obs: obs.id_medico_obs,
                },
                toast: true, 
                callback: () => this.$emit('refresh'),
            });
        }
    }
}
</script>
